import { getEnumDescription } from '@/utils/helpers'

export default function (value, list) {
  return getEnumDescription(list, value)
}
